import { PageErrorState } from "@/components/shared/PageErrorState";

interface ReportSectionErrorProps {
  message?: string;
  onRetry: () => void;
}

export function ReportSectionError({
  message = "تعذّر تحميل التقرير",
  onRetry,
}: ReportSectionErrorProps) {
  return <PageErrorState message={message} onRetry={onRetry} />;
}
